const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      productRange: 'Product Range',
      edibleCup: 'Edible Cup',
      cutleryTableware: 'Cutlery and Tableware',
      certifications: 'Certifications',
      edibleCupCertifications: 'Edible Cup Certifications',
      cutleryCertifications: 'Cutlery & Tableware Certifications',
      useCases: 'Use Cases',
      eventsCatering: 'Events and Catering',
      coffeeProducers: 'Coffee Producers',
      horeca: 'Hotels, Restaurants and Cafes',
      corporations: 'Corporations and Companies',
      privateGatherings: 'Private Gatherings',
      blog: 'Blog',
      contact: 'Contact',
      shop: 'Shop',
      login: 'Login',
      signIn: 'Sign In',
      signOut: 'Sign Out',
      myAccount: 'My Account',
      register: 'Register',
      signInRegister: 'Sign In / Register'
    },
    
    // Home Page
    home: {
      heroTitle: 'Sustainable Innovation',
      heroSubtitle: 'for a Better Tomorrow',
      heroDescription: 'Discover edible cups and tableware. Zero waste. Fully edible. Made to be enjoyed.',
      exploreProducts: 'Explore Products',
      learnMore: 'Learn More',
      tagline1: 'Edible',
      tagline2: 'Delicious',
      tagline3: 'Sustainable',
      tagline4: 'Better',
      featuredProducts: 'Featured Products',
      whyChooseUs: 'Why Choose Us',
      ecoFriendly: 'Eco-Friendly',
      ecoFriendlyDesc: '100% biodegradable and sustainable materials',
      delicious: 'Delicious',
      deliciousDesc: 'Tasty wafer cups that complement your beverage',
      innovative: 'Innovative',
      innovativeDesc: 'Leading the revolution in sustainable packaging',
      edibleCups: 'Cupffee Edible Cups',
      edibleCupsSubtitle: 'Revolutionary drinkware you can eat',
      cutleryTableware: 'Cutlery & Tableware',
      cutlerySubtitle: 'Sustainable solutions for every meal',
      exploreEdibleCups: 'Explore Edible Cups',
      exploreCutlery: 'Explore Cutlery & Tableware',
      readyToGoGreen: 'Ready to Go Green?',
      goGreenDesc: 'Magomeal brings innovative, sustainable edible products to the Benelux market. Join us in making a positive impact on the environment and local communities. Start Your Journey Now..',
      orderNow: 'Order Now',
      explore: 'Explore',
      // Feature descriptions
      edibleCupTitle: 'Cupffee Edible Cup',
      edibleCupDesc: 'Revolutionary edible packaging solutions that are crunchy and delicious, 100% bio, fully biodegradable, reduce CO₂ emissions by 75%, and made through a zero-waste production process all while protecting the environment and keeping your food fresh.',
      sustainableMaterials: 'Sustainable Materials',
      sustainableMaterialsDesc: 'Crafted from 7 sustainable, locally sourced plant-based ingredients including natural grains and coconut oil. Our edible cups are 100% vegan, GMO-free, and contain no artificial additives. Made with care through a green, zero-waste process, they\'re as pure and natural as freshly baked cookies.',
      ecoFriendlyTitle: '100% Eco-Friendly',
      ecoFriendlyDescLong: 'Every product is designed with sustainability in mind, contributing to a healthier planet for future generations.',
      sustainableTableware: 'Sustainable Tableware',
      sustainableTablewareDesc: 'Environmentally friendly tableware for catering, events, and everyday life – whether reusable or compostable.',
      edibleCutlery: 'Edible Cutlery',
      edibleCutleryDesc: 'Edible cutlery that replaces plastic and avoids waste. Simply eat it after your meal or compost it.',
      reducedPlastic: 'Reduced Plastic & Environmentally Friendly',
      reducedPlasticDesc: 'Made from safe, plant-based ingredients with no chemicals or plastics, our edible cutlery reduces plastic waste and supports a zero-waste lifestyle.'
    },
    
    // About Page
    about: {
      title: 'About MagoMeal',
      subtitle: 'Pioneering Sustainable Solutions',
      ourStory: 'Our Story',
      ourMission: 'Our Mission',
      ourVision: 'Our Vision',
      storyText: 'MagoMeal was founded with a simple yet powerful vision: to revolutionize the way we consume beverages while protecting our planet.',
      missionText: 'To provide innovative, eco-friendly alternatives to traditional disposable cups, reducing plastic waste one cup at a time.',
      visionText: 'A world where enjoying your favorite beverage doesn\'t come at the cost of our environment.'
    },
    
    // Products
    products: {
      edibleCups: 'Edible Cups',
      edibleCupsDesc: 'Discover our range of 100% edible, eco-friendly cups. Made from natural ingredients, perfect for hot and cold beverages.',
      edibleCup110: 'Edible CUP | 110 ml',
      edibleCup220: 'Edible CUP | 220 ml',
      cup110Desc: 'Perfect for espresso and small beverages',
      cup220Desc: 'Ideal for coffee, tea and medium drinks',
      viewProduct: 'View Product',
      addToCart: 'Add to Cart',
      addedToCart: 'Added to Cart!',
      inStock: 'In Stock',
      outOfStock: 'Out of Stock',
      selectQuantity: 'Select Quantity',
      soldByCarton: 'Sold by Carton',
      cupsPerCarton: 'cups per carton',
      carton: 'carton',
      cartons: 'cartons',
      cups: 'cups',
      freeShipping: 'Free shipping on orders over €50',
      sample: 'Sample',
      freeSample: 'Free sample',
      size: 'Size',
      price: 'Price',
      quantity: 'Quantity',
      total: 'Total'
    },
    
    // Product Features
    features: {
      vegan: '100% vegan',
      veganDesc: 'Handpicked for purity: only the best plant-based ingredients, including natural grains and coconut oil.',
      crunchy: 'Crunchy and delicious',
      crunchyDesc: 'The sustainable alternative to disposable cups – a tasty solution to plastic pollution!',
      gmoFree: 'GMO free',
      gmoFreeDesc: 'Just nature\'s best 100% GMO-free no artificial colorants, sweeteners or preservatives',
      natural: 'Completely natural',
      naturalDesc: 'Masterfully crafted from 7 sustainable, locally sourced ingredients of natural origin.',
      thermoResistant: 'Thermo Resistant',
      thermoResistantDesc: 'Cupffee resists high temps up to 85°C, making sure your hot drink stays contained.',
      leakProof: 'Leak-Proof',
      leakProofDesc: 'Thanks to our unique recipe, Cupffee cups won\'t leak for hours. No leaks, no worries!',
      noTasteChange: 'No Taste Change',
      noTasteChangeDesc: 'Not a fan of sugar? Cupffee won\'t change the taste of your coffee or tea.',
      lowCalorie: 'Low Calorie',
      lowCalorieDesc: 'Grab your coffee in a Cupffee for a guilt-free indulgence. Sip and snack away!',
      crunchyFeature: 'Crunchy',
      crunchyFeatureDesc: 'Tasty as a cookie, Cupffee will be crunchy from the first sip till the last bite.',
      whyChoose: 'Why Choose Our Edible Cup?'
    },
    
    // Certifications
    certifications: {
      title: 'Certifications & Specifications',
      subtitle: 'Quality and safety you can trust',
      ourCertifications: 'Our Certifications',
      productSpecs: 'Product Specifications',
      viewCertificate: 'View Certificate',
      viewSpecs: 'View Specifications'
    },
    
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'We\'d love to hear from you',
      getInTouch: 'Get in Touch',
      sendMessage: 'Send us a Message',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      address: 'Address',
      businessHours: 'Business Hours',
      mondayFriday: 'Monday - Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      closed: 'Closed'
    },
    
    // Blog
    blog: {
      title: 'Blog',
      subtitle: 'Latest news and updates',
      readMore: 'Read More',
      categories: 'Categories',
      recentPosts: 'Recent Posts'
    },
    
    // Shop
    shop: {
      title: 'Shop',
      subtitle: 'Browse our products',
      filterBy: 'Filter by',
      sortBy: 'Sort by',
      allProducts: 'All Products',
      priceHighLow: 'Price: High to Low',
      priceLowHigh: 'Price: Low to High',
      newest: 'Newest'
    },
    
    // Cart
    cart: {
      title: 'Shopping Cart',
      empty: 'Your cart is empty',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      total: 'Total',
      checkout: 'Checkout',
      continueShopping: 'Continue Shopping',
      remove: 'Remove',
      updateQuantity: 'Update Quantity',
      freeShipping: 'Free Shipping',
      calculatedAtCheckout: 'Calculated at checkout'
    },
    
    // Auth
    auth: {
      signIn: 'Sign In',
      signUp: 'Sign Up',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      firstName: 'First Name',
      lastName: 'Last Name',
      forgotPassword: 'Forgot Password?',
      noAccount: 'Don\'t have an account?',
      haveAccount: 'Already have an account?',
      createAccount: 'Create Account',
      welcomeBack: 'Welcome back!',
      createYourAccount: 'Create your account'
    },
    
    // Footer
    footer: {
      company: 'Company',
      products: 'Products',
      support: 'Support',
      legal: 'Legal',
      aboutUs: 'About Us',
      ourStory: 'Our Story',
      careers: 'Careers',
      press: 'Press',
      termsConditions: 'Terms & Conditions',
      privacyPolicy: 'Privacy Policy',
      cookiePolicy: 'Cookie Policy',
      deliveryReturn: 'Delivery & Returns',
      faq: 'FAQ',
      contactUs: 'Contact Us',
      subscribe: 'Subscribe to our newsletter',
      subscribeDesc: 'Get the latest news and updates',
      enterEmail: 'Enter your email',
      subscribeBtn: 'Subscribe',
      allRightsReserved: 'All rights reserved',
      followUs: 'Follow Us'
    },
    
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      save: 'Save',
      cancel: 'Cancel',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      search: 'Search',
      noResults: 'No results found',
      seeAll: 'See All',
      learnMore: 'Learn More',
      getStarted: 'Get Started',
      comingSoon: 'Coming Soon',
      stayTuned: 'Stay tuned for updates!'
    },
    
    // Cutlery Page
    cutlery: {
      title: 'Cutlery & Tableware',
      comingSoon: 'Coming Soon',
      comingSoonDesc: 'Our eco-friendly cutlery and tableware collection is in development. Stay tuned for sustainable dining solutions!'
    },
    
    // Cookie Consent
    cookies: {
      message: 'We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.',
      accept: 'Accept',
      decline: 'Decline',
      learnMore: 'Learn More'
    }
  },
  
  nl: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'Over Ons',
      productRange: 'Productassortiment',
      edibleCup: 'Eetbare Beker',
      cutleryTableware: 'Bestek en Servies',
      certifications: 'Certificeringen',
      edibleCupCertifications: 'Eetbare Beker Certificeringen',
      cutleryCertifications: 'Bestek & Servies Certificeringen',
      useCases: 'Toepassingen',
      eventsCatering: 'Evenementen en Catering',
      coffeeProducers: 'Koffieproducenten',
      horeca: 'Hotels, Restaurants en Cafés',
      corporations: 'Bedrijven en Organisaties',
      privateGatherings: 'Privé Bijeenkomsten',
      blog: 'Blog',
      contact: 'Contact',
      shop: 'Winkel',
      login: 'Inloggen',
      signIn: 'Inloggen',
      signOut: 'Uitloggen',
      myAccount: 'Mijn Account',
      register: 'Registreren',
      signInRegister: 'Inloggen / Registreren'
    },
    
    // Home Page
    home: {
      heroTitle: 'Duurzame Innovatie',
      heroSubtitle: 'voor een Betere Toekomst',
      heroDescription: 'Ontdek eetbare bekers en servies. Zero waste. Volledig eetbaar. Gemaakt om van te genieten.',
      exploreProducts: 'Ontdek Producten',
      learnMore: 'Meer Informatie',
      tagline1: 'Eetbaar',
      tagline2: 'Lekker',
      tagline3: 'Duurzaam',
      tagline4: 'Beter',
      featuredProducts: 'Uitgelichte Producten',
      whyChooseUs: 'Waarom Kiezen Voor Ons',
      ecoFriendly: 'Milieuvriendelijk',
      ecoFriendlyDesc: '100% biologisch afbreekbare en duurzame materialen',
      delicious: 'Heerlijk',
      deliciousDesc: 'Lekkere wafelbekers die je drankje aanvullen',
      innovative: 'Innovatief',
      innovativeDesc: 'Leidend in de revolutie van duurzame verpakkingen',
      edibleCups: 'Eetbare Bekers',
      edibleCupsSubtitle: 'Revolutionair drinkgerei dat je kunt eten',
      cutleryTableware: 'Bestek & Servies',
      cutlerySubtitle: 'Duurzame oplossingen voor elke maaltijd',
      exploreEdibleCups: 'Ontdek Eetbare Bekers',
      exploreCutlery: 'Ontdek Bestek & Servies',
      readyToGoGreen: 'Klaar om Groen te Gaan?',
      goGreenDesc: 'Magomeal brengt innovatieve, duurzame eetbare producten naar de Benelux-markt. Doe mee aan het maken van een positieve impact op het milieu en lokale gemeenschappen. Begin Nu Je Reis..',
      orderNow: 'Bestel Nu',
      explore: 'Ontdek',
      // Feature descriptions
      edibleCupTitle: 'Cupffee Eetbare Beker',
      edibleCupDesc: 'Revolutionaire eetbare verpakkingsoplossingen die knapperig en heerlijk zijn, 100% bio, volledig biologisch afbreekbaar, CO₂-uitstoot met 75% verminderen, en gemaakt door een zero-waste productieproces terwijl het milieu wordt beschermd en je voedsel vers blijft.',
      sustainableMaterials: 'Duurzame Materialen',
      sustainableMaterialsDesc: 'Vervaardigd uit 7 duurzame, lokaal ingekochte plantaardige ingrediënten waaronder natuurlijke granen en kokosolie. Onze eetbare bekers zijn 100% veganistisch, GMO-vrij en bevatten geen kunstmatige toevoegingen. Met zorg gemaakt door een groen, zero-waste proces, ze zijn zo puur en natuurlijk als versgebakken koekjes.',
      ecoFriendlyTitle: '100% Milieuvriendelijk',
      ecoFriendlyDescLong: 'Elk product is ontworpen met duurzaamheid in gedachten, wat bijdraagt aan een gezondere planeet voor toekomstige generaties.',
      sustainableTableware: 'Duurzaam Servies',
      sustainableTablewareDesc: 'Milieuvriendelijk servies voor catering, evenementen en het dagelijks leven – herbruikbaar of composteerbaar.',
      edibleCutlery: 'Eetbaar Bestek',
      edibleCutleryDesc: 'Eetbaar bestek dat plastic vervangt en afval voorkomt. Eet het gewoon op na je maaltijd of composteer het.',
      reducedPlastic: 'Minder Plastic & Milieuvriendelijk',
      reducedPlasticDesc: 'Gemaakt van veilige, plantaardige ingrediënten zonder chemicaliën of plastic, ons eetbare bestek vermindert plastic afval en ondersteunt een zero-waste levensstijl.'
    },
    
    // About Page
    about: {
      title: 'Over MagoMeal',
      subtitle: 'Pionieren in Duurzame Oplossingen',
      ourStory: 'Ons Verhaal',
      ourMission: 'Onze Missie',
      ourVision: 'Onze Visie',
      storyText: 'MagoMeal werd opgericht met een eenvoudige maar krachtige visie: de manier waarop we dranken consumeren revolutioneren en tegelijkertijd onze planeet beschermen.',
      missionText: 'Innovatieve, milieuvriendelijke alternatieven bieden voor traditionele wegwerpbekers, waarbij we plastic afval verminderen, één beker per keer.',
      visionText: 'Een wereld waarin genieten van je favoriete drankje niet ten koste gaat van ons milieu.'
    },
    
    // Products
    products: {
      edibleCups: 'Eetbare Bekers',
      edibleCupsDesc: 'Ontdek ons assortiment 100% eetbare, milieuvriendelijke bekers. Gemaakt van natuurlijke ingrediënten, perfect voor warme en koude dranken.',
      edibleCup110: 'Eetbare Beker | 110 ml',
      edibleCup220: 'Eetbare Beker | 220 ml',
      cup110Desc: 'Perfect voor espresso en kleine drankjes',
      cup220Desc: 'Ideaal voor koffie, thee en middelgrote drankjes',
      viewProduct: 'Bekijk Product',
      addToCart: 'In Winkelwagen',
      addedToCart: 'Toegevoegd!',
      inStock: 'Op Voorraad',
      outOfStock: 'Niet Op Voorraad',
      selectQuantity: 'Selecteer Aantal',
      soldByCarton: 'Verkocht per Doos',
      cupsPerCarton: 'bekers per doos',
      carton: 'doos',
      cartons: 'dozen',
      cups: 'bekers',
      freeShipping: 'Gratis verzending bij bestellingen boven €50',
      sample: 'Monster',
      freeSample: 'Gratis monster',
      size: 'Maat',
      price: 'Prijs',
      quantity: 'Aantal',
      total: 'Totaal'
    },
    
    // Product Features
    features: {
      vegan: '100% veganistisch',
      veganDesc: 'Zorgvuldig geselecteerd voor zuiverheid: alleen de beste plantaardige ingrediënten, waaronder natuurlijke granen en kokosolie.',
      crunchy: 'Knapperig en heerlijk',
      crunchyDesc: 'Het duurzame alternatief voor wegwerpbekers – een smakelijke oplossing voor plasticvervuiling!',
      gmoFree: 'GMO-vrij',
      gmoFreeDesc: 'Alleen het beste van de natuur, 100% GMO-vrij, geen kunstmatige kleurstoffen, zoetstoffen of conserveringsmiddelen',
      natural: 'Volledig natuurlijk',
      naturalDesc: 'Vakkundig vervaardigd uit 7 duurzame, lokaal ingekochte ingrediënten van natuurlijke oorsprong.',
      thermoResistant: 'Warmtebestendig',
      thermoResistantDesc: 'Cupffee is bestand tegen hoge temperaturen tot 85°C, zodat je warme drankje veilig blijft.',
      leakProof: 'Lekvrij',
      leakProofDesc: 'Dankzij ons unieke recept lekken Cupffee-bekers urenlang niet. Geen lekken, geen zorgen!',
      noTasteChange: 'Geen Smaakverandering',
      noTasteChangeDesc: 'Geen fan van suiker? Cupffee verandert de smaak van je koffie of thee niet.',
      lowCalorie: 'Weinig Calorieën',
      lowCalorieDesc: 'Pak je koffie in een Cupffee voor een schuldvrij genotsmomentje. Nippen en snacken!',
      crunchyFeature: 'Knapperig',
      crunchyFeatureDesc: 'Lekker als een koekje, Cupffee blijft knapperig van de eerste slok tot de laatste hap.',
      whyChoose: 'Waarom Kiezen voor Onze Eetbare Beker?'
    },
    
    // Certifications
    certifications: {
      title: 'Certificeringen & Specificaties',
      subtitle: 'Kwaliteit en veiligheid waar u op kunt vertrouwen',
      ourCertifications: 'Onze Certificeringen',
      productSpecs: 'Productspecificaties',
      viewCertificate: 'Bekijk Certificaat',
      viewSpecs: 'Bekijk Specificaties'
    },
    
    // Contact
    contact: {
      title: 'Contact',
      subtitle: 'We horen graag van u',
      getInTouch: 'Neem Contact Op',
      sendMessage: 'Stuur ons een Bericht',
      name: 'Naam',
      email: 'E-mail',
      phone: 'Telefoon',
      subject: 'Onderwerp',
      message: 'Bericht',
      send: 'Verstuur Bericht',
      address: 'Adres',
      businessHours: 'Openingstijden',
      mondayFriday: 'Maandag - Vrijdag',
      saturday: 'Zaterdag',
      sunday: 'Zondag',
      closed: 'Gesloten'
    },
    
    // Blog
    blog: {
      title: 'Blog',
      subtitle: 'Laatste nieuws en updates',
      readMore: 'Lees Meer',
      categories: 'Categorieën',
      recentPosts: 'Recente Berichten'
    },
    
    // Shop
    shop: {
      title: 'Winkel',
      subtitle: 'Bekijk onze producten',
      filterBy: 'Filteren op',
      sortBy: 'Sorteren op',
      allProducts: 'Alle Producten',
      priceHighLow: 'Prijs: Hoog naar Laag',
      priceLowHigh: 'Prijs: Laag naar Hoog',
      newest: 'Nieuwste'
    },
    
    // Cart
    cart: {
      title: 'Winkelwagen',
      empty: 'Je winkelwagen is leeg',
      subtotal: 'Subtotaal',
      shipping: 'Verzending',
      total: 'Totaal',
      checkout: 'Afrekenen',
      continueShopping: 'Verder Winkelen',
      remove: 'Verwijderen',
      updateQuantity: 'Aantal Bijwerken',
      freeShipping: 'Gratis Verzending',
      calculatedAtCheckout: 'Berekend bij afrekenen'
    },
    
    // Auth
    auth: {
      signIn: 'Inloggen',
      signUp: 'Registreren',
      email: 'E-mail',
      password: 'Wachtwoord',
      confirmPassword: 'Bevestig Wachtwoord',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      forgotPassword: 'Wachtwoord Vergeten?',
      noAccount: 'Nog geen account?',
      haveAccount: 'Heeft u al een account?',
      createAccount: 'Account Aanmaken',
      welcomeBack: 'Welkom terug!',
      createYourAccount: 'Maak uw account aan'
    },
    
    // Footer
    footer: {
      company: 'Bedrijf',
      products: 'Producten',
      support: 'Ondersteuning',
      legal: 'Juridisch',
      aboutUs: 'Over Ons',
      ourStory: 'Ons Verhaal',
      careers: 'Carrières',
      press: 'Pers',
      termsConditions: 'Algemene Voorwaarden',
      privacyPolicy: 'Privacybeleid',
      cookiePolicy: 'Cookiebeleid',
      deliveryReturn: 'Levering & Retour',
      faq: 'Veelgestelde Vragen',
      contactUs: 'Contact',
      subscribe: 'Abonneer op onze nieuwsbrief',
      subscribeDesc: 'Ontvang het laatste nieuws en updates',
      enterEmail: 'Vul uw e-mail in',
      subscribeBtn: 'Abonneren',
      allRightsReserved: 'Alle rechten voorbehouden',
      followUs: 'Volg Ons'
    },
    
    // Common
    common: {
      loading: 'Laden...',
      error: 'Fout',
      success: 'Succes',
      save: 'Opslaan',
      cancel: 'Annuleren',
      close: 'Sluiten',
      back: 'Terug',
      next: 'Volgende',
      previous: 'Vorige',
      search: 'Zoeken',
      noResults: 'Geen resultaten gevonden',
      seeAll: 'Alles Bekijken',
      learnMore: 'Meer Informatie',
      getStarted: 'Aan de Slag',
      comingSoon: 'Binnenkort Beschikbaar',
      stayTuned: 'Blijf op de hoogte voor updates!'
    },
    
    // Cutlery Page
    cutlery: {
      title: 'Bestek & Servies',
      comingSoon: 'Binnenkort Beschikbaar',
      comingSoonDesc: 'Onze milieuvriendelijke bestek- en serviescollectie is in ontwikkeling. Blijf op de hoogte voor duurzame eetoplossingen!'
    },
    
    // Cookie Consent
    cookies: {
      message: 'Wij gebruiken cookies om uw ervaring te verbeteren. Door deze site te blijven bezoeken, gaat u akkoord met ons gebruik van cookies.',
      accept: 'Accepteren',
      decline: 'Weigeren',
      learnMore: 'Meer Informatie'
    }
  }
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    if (value && value[k]) {
      value = value[k];
    } else {
      // Fallback to English
      value = translations.en;
      for (const fallbackKey of keys) {
        if (value && value[fallbackKey]) {
          value = value[fallbackKey];
        } else {
          return key; // Return key if translation not found
        }
      }
      break;
    }
  }
  
  return value;
};

export const useTranslation = (language) => {
  const t = (key) => getTranslation(language, key);
  return { t };
};

export default translations;
